export const categories = [
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '让你捧腹大笑的欢乐时刻' },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line', description: '舌尖上的美味之旅' },
  { slug: 'shenghuo', name: '生活', icon: 'ri-heart-line', description: '记录美好生活点滴' },
  { slug: 'caiyi', name: '才艺', icon: 'ri-music-line', description: '展示你的独特才华' },
  { slug: 'lvxing', name: '旅行', icon: 'ri-earth-line', description: '带你走遍世界各地' },
  { slug: 'keji', name: '科技', icon: 'ri-computer-line', description: '前沿科技一手掌握' },
  { slug: 'yundong', name: '运动', icon: 'ri-run-line', description: '挥洒汗水的运动激情' },
  { slug: 'dongwu', name: '萌宠', icon: 'ri-bear-smile-line', description: '可爱萌宠治愈心灵' },
];

export const categoryNames: Record<string, string> = {};
categories.forEach((c) => { categoryNames[c.slug] = c.name; });